import { game } from './game.icon-data'
import { play } from './play.icon-data'
import { provide } from './provide.icon-data'

export const home = { game, play, provide }
